module.exports = __webpack_public_path__ + "img/v1-5.744d52c7.png";